import { Fragment } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import ErrorBox from '../../../general/ErrorBox'
import ImagesMovieDisplayAndUploadList from './ImagesMovieDisplayAndUploadList'

const ImagesMovieDisplayAndUploadComponent = ({
    images,
    movieTitle,
    isDisabled,
    isUploading,
    errorMessages,
    onUploadStart,
    imageType,
    onUploadEndSuccess,
    onUploadEndError,
    onResetErrorMessages,
    setMovieImages,
    onImagesTouched,
    autoUpload,
})  => {
    return (
        <DndProvider backend={HTML5Backend}>
            <Fragment>
                {isUploading && <div className='overlay'>
                    <div className="spinner"></div>
                </div>}

                <ImagesMovieDisplayAndUploadList
                    dndItems={images}
                    movieTitle={movieTitle}
                    isUploading={isUploading}
                    isDisabled={isDisabled}
                    imageType={imageType}
                    autoUpload={autoUpload}
                    onUploadStart={onUploadStart}
                    onUploadEndSuccess={onUploadEndSuccess}
                    onUploadEndError={onUploadEndError}
                    onResetErrorMessages={onResetErrorMessages}
                    setMovieImages={setMovieImages}
                    onImagesTouched={onImagesTouched}
                />

                <ErrorBox messages={errorMessages} />
            </Fragment>
        </DndProvider>
    )
}

export default ImagesMovieDisplayAndUploadComponent
